<template>
  <div style="height: 100%;">
    <div class="main" @click="recommend.show= false" v-show="chatDataCenter.showChatPage" >
      <div id="smartnlp-FrameBlock" :class="chatDataCenter.set.windowSize=='2'&&chatDataCenter.set.isIFrame?'robot-iframe-mini':(chatDataCenter.set.windowSize=='2'?'robot-mini':'robot-small')">
        <div id="poper-smartnlp-FrameBlock" style="position: relative;width: 100%;height: 100%">
          <div :class="chatDataCenter.set.windowSize=='1'?'smartnlp-header':'smartnlp-header1'" :style="'background:'+ chatDataCenter.linkInfo.windowColor" >
            <div class="smartnlp-infobar-pic"  v-if="chatDataCenter.linkInfo.windowLogo!=undefined" :style="'borderColor:'+chatDataCenter.linkInfo.windowColor">
              <img :src="$config.fileUrl+chatDataCenter.linkInfo.windowLogo">
            </div>
            <!--<span class="smartnlp-robot-name"  v-if="chatDataCenter.chatRoom.sessionType=='2'&&chatDataCenter.chatRoom.userId!=null&&chatDataCenter.chatRoom.queueFlag==0">-->
            <!--{{chatDataCenter.userSetInfo==null||chatDataCenter.userSetInfo.nickname==''||chatDataCenter.userSetInfo.nickname==null?chatDataCenter.linkInfo.artificialName:chatDataCenter.userSetInfo.nickname}}-->
            <!--({{chatDataCenter.chatRoom.senderType==1?'顾客':chatDataCenter.chatRoom.senderType==2?'客服':''}}{{chatDataCenter.chatRoom.getWaitTime()}})-->
            <!--</span>-->
            <span class="smartnlp-robot-name">{{chatDataCenter.linkInfo.windowTitle}}</span>
            <div class="smartnlp-toolbar">
                    <span class="smartnlp-toolbar-voice" title="开/关 声音" v-if="chatDataCenter.chatRoom.sessionType=='2'">
                        <img v-if="chatDataCenter.set.tipSound=='1'" src="../../../static/images/horn-c.png" @click="chatDataCenter.set.tipSound='2'">
                        <img v-if="chatDataCenter.set.tipSound=='2'" src="../../../static/images/horn-x.png" @click="chatDataCenter.set.tipSound='1'">
                    </span>
              <span class="smartnlp-toolbar-large" title="最小化" v-if="chatDataCenter.set.isIFrame">
                        <img src="../../../static/images/min-c.png" @click="hideIframe()">
                    </span>
              <span class="smartnlp-toolbar-large" title="最大化">
                        <img src="../../../static/images/max-c.png" @click="changeIframeSize()">
                    </span>
              <span class="smartnlp-toolbar-close" title="关闭">
                        <img src="../../../static/images/close-c.png" v-if="chatDataCenter.set.isIFrame||chatDataCenter.chatRoom.sessionType=='2'" @click="closeSessionByCustomer" >
                    </span>
            </div>
          </div>

          <div :class="chatDataCenter.set.windowSize=='1'?'smartnlp-chat-main':'smartnlp-chat-main1'">
            <div id="RightCont" :class="chatDataCenter.set.windowSize=='1'?'smartnlp-chat-main-left':'smartnlp-chat-main-left1'">
              <div :class="chatDataCenter.bottomLabel.length > 0 ? 'smartnlp-chat-msg-show-button' : 'smartnlp-chat-msg-show'">
                <div class="smartnlp-notice" v-if="chatDataCenter.notice.show&&chatDataCenter.notice.noticeInfo.title!=null&&chatDataCenter.notice.noticeInfo.title!=''">
                  <img src="../../../static/images/t-c.png"> <span @click="detail">{{chatDataCenter.notice.noticeInfo.title}}</span> <a class="notice-close" @click="chatDataCenter.notice.show=false"> <img src="../../../static/images/c.png"> </a>
                </div>
                <!--smartnlp-chat-msg-content1-->
                <!--<div class="Message" :class="chatDataCenter.chatRoom.sessionType=='1' ? 'smartnlp-chat-msg-content' : 'smartnlp-chat-msg-content1'">-->
                <div class="Message smartnlp-chat-msg-content1 contentDiv2">
                  <div class="smartnlp-chatRecord">
                    <a v-if="chatDataCenter.isLoadMessage" @click="loadHistoryMessages()">点击加载更多</a>
                  </div>
                  <ul class="smartnlp-msg-history-list" v-if="chatDataCenter.chatRoom!= null"  >
                    <li v-for="(item, index) in chatDataCenter.chatRoom.messages">
                      <!--系统消息 -->
                      <div class="martnlp-system" v-if="item.messageDirection=='S'&&item.messageType!='S2'">{{item.getSendTime()}}
                        <span v-html="item.getSystemHtml(chatDataCenter.chatRoom.sessionId,item.sessionId==chatDataCenter.chatRoom.sessionId)"></span>
                      </div>
                      <div class="martnlp-system" v-if="item.messageDirection=='U'&&item.messageStatus==40">{{item.getSendTime()}} 客服撤回一条消息 </div>
                      <!--用户->客服 -->
                      <div class="smartnlp-msg-model smartnlp-right-msg clearfix" v-if="item.messageDirection=='C'">
                        <div v-if="chatDataCenter.set.windowSize=='1'" class="smartnlp-msg-head-pic">
                          <img v-if="(item.senderAvatar==null||item.senderAvatar=='')&&chatDataCenter.linkInfo!=null" :src="$config.fileUrl+chatDataCenter.linkInfo.userAvator">
                          <img v-if="item.senderAvatar!=null&&item.senderAvatar!=''" :src="$config.fileUrl+item.senderAvatar">
                        </div>
                        <div class="smartnlp-msg-content clearfix">
                          <p class="smartnlp-right-name"><span>{{item.getSendTime()}}</span>
                            <span v-if="item.senderNickname==null||item.senderNickname==''">我</span>
                            <span v-else>我</span></p>
                          <div class="smartnlp-msg-news smartnlp-msg-right-color clearfix fadeIn" :style="'background:'+ chatDataCenter.linkInfo.windowColor">
                            <v-message-show v-if="item.showType()" :message="item" ></v-message-show>
                            <p v-if="!item.showType()" v-html="item.getHtml()"></p>
                          </div>
                        </div>
                        <div class="error-right" title="发送失败" v-show="item.messageStatus == -1"> <img src="../../../static/images/fail.png"/></div>
                        <div class="yidu-right" v-show="item.messageStatus == 0">发送中</div>
                        <!--<div class="weidu-right" v-show="item.messageStatus==10">未读</div>-->
                        <!--<div class="yidu-right" v-show="item.messageStatus == 20">已读</div>-->

                      </div>
                      <!--客服->用户 -->
                      <div class="smartnlp-msg-model smartnlp-left-msg clearfix contentDiv"  v-if="item.messageDirection=='U'&&$messageType.L!=item.messageType&&item.messageStatus!=40">
                        <div v-if="chatDataCenter.set.windowSize=='1'&&item.messageType == 'R'" class="smartnlp-msg-head-pic">
                          <img v-if="chatDataCenter.linkInfo!=null" :src="$config.fileUrl+chatDataCenter.linkInfo.robotAvator">
                        </div>
                        <div v-if="chatDataCenter.set.windowSize=='1'&&item.messageType != 'R'&& item.messageType != 'H'" class="smartnlp-msg-head-pic">
                          <img v-if="(item.senderAvatar==null||item.senderAvatar=='')&&chatDataCenter.linkInfo!=null" :src="$config.fileUrl+chatDataCenter.linkInfo.artificialAvator">
                          <img v-if="item.senderAvatar!=null&&item.senderAvatar!=''" :src="$config.fileUrl+item.senderAvatar">
                        </div>
                        <div class="smartnlp-msg-content clearfix">
                          <p class="smartnlp-left-name" v-if="item.messageType == 'R'" > <span v-if="chatDataCenter.linkInfo!=null">{{chatDataCenter.linkInfo.robotName}}</span> <span>{{item.getSendTime()}}</span></p>
                          <p class="smartnlp-left-name" v-if="item.messageType != 'R'&& item.messageType != 'H'" >
                            <span v-if="(item.senderNickname==null||item.senderNickname=='')&&chatDataCenter.linkInfo!=null">{{chatDataCenter.linkInfo.artificialName}}</span>
                            <span v-if="item.senderNickname!=null&&item.senderNickname!=''">{{item.senderCode==""||item.senderCode==null?item.senderNickname:(item.senderNickname+'('+item.senderCode+')')}}</span>
                            <span>{{item.getSendTime()}}</span>
                          </p>
                          <div class="smartnlp-msg-answer smartnlp-msg-left-color clearfix fadeInUp" v-if="item.showType() && item.messageType != 'H'"  :class="chatDataCenter.set.windowSize=='1'?'width-answer':'width-answer1'">
                            <div :style="{ height: item.height, overflow: 'hidden' }">
                              <v-message-show :message="item"></v-message-show>
                            </div>
                            <!--用于长文本的展开收起高度改变-->
                            <div
                              class="openMore"
                              v-if="item.isHasOpen"
                              @click="foldMore(item, $event)"
                            >
                              <span>{{ item.isOpen ? "收起" : "展开" }}</span>
                              <img
                                src="../../../static/images/iconArrowDown.png"
                                class="openImg"
                                v-if="!item.isOpen"
                              />
                              <img
                                src="../../../static/images/iconArrowUp.png"
                                class="openImg"
                                v-if="item.isOpen"
                              />
                            </div>
                            <v-solve-show :message="item" :messageIndex="index"></v-solve-show>
                          </div>
                          <div class="smartnlp-msg-answer smartnlp-msg-left-color clearfix fadeIn" v-if="!item.showType() && item.messageType != 'H'" :class="chatDataCenter.set.windowSize=='1'?'width-answer':'width-answer1'">
                            <div style="padding: 8px 15px;" :style="{ height: item.height, overflow: 'hidden' }" v-if="!item.showType() && !item.answerType">
                              <viewer>
                                <p v-html="item.getHtml()"></p>
                              </viewer>
                            </div>
                            <div style="padding: 8px 15px;" :style="{ height: item.height, overflow: 'hidden' }" v-if="item.answerType && item.answerType ==='json' && item.getHtml()">
                              <viewer>
                                <!-- json类型答案且引导话术不为空 -->
                                <p  v-html="item.getHtml()"></p>
                              </viewer>
                            </div>
                            <!--用于长文本的展开收起高度改变-->
                            <div
                              class="openMore"
                              v-if="item.isHasOpen"
                              @click="foldMore(item, $event)"
                            >
                              <span>{{ item.isOpen ? "收起" : "展开" }}</span>
                              <img
                                src="../../../static/images/iconArrowDown.png"
                                class="openImg"
                                v-if="!item.isOpen"
                              />
                              <img
                                src="../../../static/images/iconArrowUp.png"
                                class="openImg"
                                v-if="item.isOpen"
                              />
                            </div>
                            <v-solve-show :message="item" :messageIndex="index"></v-solve-show>

                          </div>
                          <json-card v-if="item.answerType && item.answerType === 'json'" :message="item" />
                        </div>
                        <hot-question v-if="item.messageType === 'H' &&chatDataCenter.labelListNew.length > 0"/>
                        <quick-entry v-if="item.messageType === 'H' && chatDataCenter.quickEntryList.length > 0" />
                      </div>

                      <!--机器人待回复动画 -->
                      <div class="smartnlp-msg-model smartnlp-left-msg clearfix fadeIn" v-if="item.messageDirection=='U'&&$messageType.L==item.messageType">
                        <div class="smartnlp-loading">
                          <img src="../../../static/images/loading.gif"/>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <!--<div class="smartnlp-tool-block clearfix" v-if="chatDataCenter.chatRoom.sessionType=='1'">-->
                <!--<a class="smartnlp-pre" @click="quickConsultPre"><img  src="../../../static/images/left.png"></a>-->
                <!--<a class="smartnlp-next" @click="quickConsultNext"><img src="../../../static/images/right.png"></a>-->
                <!--<span class="smartnlp-tool-list fadeInRight"><a :class="{'smartnlp-tool-active':index==chatDataCenter.quickConsult.chooseIndex}"  @click="quickConsultSendByContent(index,item)"  v-for="(item,index) in chatDataCenter.quickConsult.list" >{{item}}</a></span>-->
                <!--</div>-->
              </div>
              <div :class="chatDataCenter.bottomLabel.length > 0 ? 'smartnlp-chat-msg-input-button' : 'smartnlp-chat-msg-input'">
                <div class="bottomButton">
                  <bottom-label v-if="chatDataCenter.bottomLabel.length > 0"/>
                </div>
                <!--推荐答案-->
                <div class="smartnlp-jiansuo" v-show="recommend.show">
                  <ul>
                    <li :class="{'current-active':index==recommend.chooseIndex}" @click="useMessageByContent(index,item.text)" v-for="(item,index) in recommend.list">
                      <img src="../../../static/images/icon_zhi.png"><span v-html="item.text"></span>
                    </li>
                  </ul>
                </div>


                <div :class="chatDataCenter.bottomLabel.length > 0 ? 'smartnlp-write-block-botton' : 'smartnlp-write-block'">

                  <div class="smartnlp-tool-left" v-show="!robotSessionFlag">
                    <a title="图片" style="padding: 0 8px;">
                      <v-upload-file :fileInfo="image" @fromUploadFilePage="fromUploadData"></v-upload-file>
                    </a>
                    <a title="文件" style="padding: 0 8px;">
                      <v-upload-file :fileInfo="file" @fromUploadFilePage="fromUploadData"></v-upload-file>
                    </a>
                    <a title="评价" style="padding: 0 8px;" v-if="chatDataCenter.chatRoom.customerEvaluate==null||chatDataCenter.chatRoom.customerEvaluate==0" @click="evaluateByCustomer"><img src="../../../static/images/shoucang.png"></a>
                  </div>
                  <div id="editorElem" style="height: 100%;" ></div>
                  <!--<textarea class="inputfocus" placeholder="请输入您要咨询的问题" v-show="inputShow" @click="focusTextArea" ></textarea>-->
                </div>
                <div class="smartnlp-power-bottom" @click="editorFocus()">
                  <a v-if="getRobotToUserButton()=='1'" @click="transferStaffSession" class="rengong-button">人工客服</a>
                  <a class="smartnlp-send" style="color: #ffffff" :class="showFlag.sendShow ? 'smartnlp-send-00b9ff' : 'smartnlp-send-999'" @click="sendMessage">发送</a>
                </div>
                <!--<span class="smartnlp-bottom-in">Powered By 奇智机器人</span>-->
              </div>

              <div class="smartnlp-chat-msg-input-disabled" v-if="chatDataCenter.chatRoom==null||chatDataCenter.chatRoom.sessionId==null">
                <p>当前会话已结束，您可以：</p>
                <div class="disabled-button">
                  <a class="zixun" :style="'color:'+ chatDataCenter.linkInfo.windowColor+';borderColor:'+ chatDataCenter.linkInfo.windowColor" @click="reJoin">重新接入</a>
                  <a  class="pingjia" v-if="(chatDataCenter.chatRoom.customerEvaluate==null||chatDataCenter.chatRoom.customerEvaluate==0)&&chatDataCenter.evaluation.sessionId!=null&&chatDataCenter.evaluation.customerEvaluate === 0" @click="evaluateByCustomer">评价</a>
                </div>
              </div>
            </div>
            <div class="smartnlp-chat-main-right" v-show="chatDataCenter.set.windowSize=='1'" >
              <v-right-show ></v-right-show>
            </div>
          </div>
          <v-evaluation></v-evaluation>
          <v-leave-message></v-leave-message>

          <feedback v-if="chatDataCenter.isOpenFeedback"></feedback>
          <v-loading v-if="chatDataCenter.loadPage.initLoad||(chatDataCenter.loadPage.requestLoad&&chatDataCenter.loadPage.initLoad)"></v-loading>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import chatDataCenter from "../../jsSdk/chatDataCenter";
  import vRightShow from "./rightShow";
  import vLoading from "./loading";
  import vEvaluation from "./evaluation";
  import vLeaveMessage from "./leaveMessage";
  import vMessageShow from "../common/messageShow";
  import vSolveShow from "../common/solveShow";
  import E from "wangeditor"
  import vUploadFile from '../common/uploadFile';
  import emoji from "../../jsSdk/emoji/emoji";
  import bus from '../../utils/bus';
  import feedback from "../common/feedback";
  import jsonCard from "../common/jsonCard";
  export default {
    name: 'medium',
    components:{
      vRightShow,
      vEvaluation,
      vLeaveMessage,
      vMessageShow,
      vUploadFile,
      vLoading,
      vSolveShow,
      hotQuestion:() => import("../common/hotQuestion"),
      bottomLabel:() => import("../common/bottomLabel"),
      feedback,
      jsonCard,
      quickEntry:() => import("../common/quickEntry"),
    },
    methods:{
      initPage:function () {
        var _this=this
        bus.$on("changeEdit", (name) => {
          if(chatDataCenter.chatRoom!=null&&chatDataCenter.chatRoom.sessionId!=null&&chatDataCenter.chatRoom.sessionType==2&&chatDataCenter.chatRoom.userId!=null){
            _this.initEditor(true);
            _this.robotSessionFlag=false;
          }else {
            _this.robotSessionFlag=true;
            _this.initEditor(false);
          }
        });
        bus.$on("scrollToBottomWeb", (type) => {
          if(type=='2'){
            setTimeout(function () {
              _this.scrollToBottom();
            }, 500);
          }else {
            _this.scrollToBottom();
          }
        });
        // 监听Iframe页面postMessage
        window.addEventListener('message',function(e){
          if(e.data == 'showPage'){// 打开窗口大小
            chatDataCenter.set.windowFlag='1'
            chatDataCenter.chatRoom.readMessages()
            chatDataCenter.scrollToBottom("1")
          }else if(e.data == 'hidePage'){// 隐藏聊天窗口
            chatDataCenter.set.windowFlag='2'
          }
        },false);
      },
      scrollToBottom:function () {
        var _this=this
        _this.$nextTick(() => {
          var container = _this.$el.querySelector(".Message");
          if(container!=undefined&&container!=null){
            container.scrollTop = container.scrollHeight;
          }
        });
      },
      /**
       * 评价
       */
      evaluateByCustomer:function () {
        chatDataCenter.evaluation.closeType='6';//顾客主动评价
        chatDataCenter.evaluation.show=true
      },
      reJoin:function () {
        chatDataCenter.clickEvent('#重新接入#',this)
      },
      hideIframe:function () {
        if(parent){
          parent.postMessage('hideIframe', '*');
          chatDataCenter.set.windowFlag='2'
        }
      },
      changeIframeSize:function () {
        if(parent){
          if(chatDataCenter.set.windowSize=='1'){
            parent.postMessage('changeIframeSize','*');
            chatDataCenter.set.windowSize = '2';
          }else{
            parent.postMessage('changeIframeSize','*');
            chatDataCenter.set.windowSize = '1';
          }
          chatDataCenter.scrollToBottom("1");
        }
      },
      focusTextArea:function () {
        alert('focusTextArea');
        this.editorFocus();
        this.inputShow=false;

      },
      /**
       * 富文本样式
       */
      initEditor:function (showEmoji){
        var content = "";
        if(this.editor){
          content = this.editor.txt.html();
        }
        var _this = this;
        document.getElementById('editorElem').innerHTML = '';
        this.editor = new E('#editorElem');
        if(showEmoji){
          this.editor.customConfig.menus = ['emoticon'];
        }else{
          this.editor.customConfig.menus = [];
        }
        // this.editor.customConfig.onblur = function (html) {
        //     alert('BlurEditor');
        //     var text=_this.getEditorText();
        //     if(text==''){
        //         _this.inputShow=true;
        //     }
        // };
        // this.editor.customConfig.onfocus = function () {
        //     alert('FocusEditor')
        // };

        this.editor.customConfig.onchange = (html) => {
          chatDataCenter.chatRoom.inputting = html
          var text=_this.getText();
          if(text==''){
            _this.showFlag.sendShow=false;
          }else {
            _this.showFlag.sendShow=true;
          }
          if(chatDataCenter.linkInfo!=null&&chatDataCenter.linkInfo.inputAssociate==1&&_this.recommend.searchFlag){
            if(_this.editor.txt.text()!=''){
              _this.robotQuestion(_this.editor.txt.text())
            }else {
              _this.initRecommendInfo(false,[])
            }
          }
        };
        // this.editor.customConfig.onkeyup = function () {
        //     chatDataCenter.chatRoom.inputting = _this.editor.txt.html()
        //     if(chatDataCenter.linkInfo!=null&&chatDataCenter.linkInfo.inputAssociate==1&&_this.recommend.searchFlag){
        //         if(_this.editor.txt.text()!=''){
        //             _this.robotQuestion(_this.editor.txt.text())
        //         }else {
        //             _this.initRecommendInfo(false,[])
        //         }
        //     }
        // };
        this.editor.customConfig.onkeydown = function (event) {
          event = event||window.event;
          var keyCode = event.keyCode ||event.which ||event.charCode;
          if (event.ctrlKey && keyCode == 13) {
            _this.editor.txt.html(_this.editor.txt.html()+"<br>");
          } else if (keyCode == 13) {
            var ctrlKey = event.ctrlKey;
            if(!ctrlKey){
              _this.sendMessage();
              _this.recommend.searchFlag=true
              event.preventDefault();
              _this.recommend.show=false;

            }
          }
        };

        //表情
        var emojiContent = [];
        for(var i = 0; i < emoji.getEmojis().length; i++){
          emojiContent.push({
            alt:emoji.getEmojis()[i][0],
            src:emoji.getEmojiSrc(i)
          })
        }
        this.editor.customConfig.emotions = [
          {
            title: '默认',
            type: 'image',
            content: emojiContent
          }
        ];
        // 自定义处理粘贴的文本内容
        this.editor.customConfig.pasteTextHandle = function (content) {
          return content // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
        }
        this.editor.customConfig.pasteFilterStyle = true  // 关闭粘贴样式的过滤
        this.editor.customConfig.pasteIgnoreImg = false
        this.editor.customConfig.customUploadImg = function (files, insert) {
          for (var i=0;i<files.length;i++) {
            var formData = new FormData();
            formData.append("groupName", _this.$config.group1);
            formData.append("multipartFile",files[i]);
            _this.$axiosService.postFile('minio/uploadFile',formData, response => {
              if(response.code==0){
                insert(_this.$config.fileUrl+response.data.fullPath)
              }
            });
          }
        }
        this.editor.create();
        if(content != ""){
          this.editor.txt.html(content);
        }
      },

      editorFocus:function () {
        if(this.editor){
          this.editor.txt.html(this.editor.txt.html());
        }
      },

      /**
       * 加载更多
       */
      loadHistoryMessages:function () {
        chatDataCenter.chatRoom.loadHistoryMessages(this,"",function () {

        })
      },
      /**
       * 机器人回答
       */
      robotQuestion:function (question) {
        var _this=this;
        var questionList=[];
        if(chatDataCenter.robotInfo!=null&&chatDataCenter.robotInfo.bindId!=''){
          _this.$axiosService.getCloud('/cloud/custom/getSimilarQuestions',{
            robotId:chatDataCenter.robotInfo.bindId,
            question:question,
          }, function (response) {
            if (response.success){
              var res=response.data
              for (var i=0;i<res.data.length;i++){
                if(i<5){
                  questionList.push({text:res.data[i]})
                }
              }
              if(questionList.length>0){
                _this.initRecommendInfo(true,questionList)
              }
            }
          });
        }
      },

      initRecommendInfo:function (show,list) {
        this.recommend.show=show;
        this.recommend.list=list;
        var _this = this;
        _this.recommend.chooseIndex= -1;
        document.onkeydown=function(ev){
          ev = ev||window.event;
          if(_this.recommend.show){
            var keyCode = ev.keyCode ||ev.which ||ev.charCode;
            if(keyCode == 38){//上移
              _this.recommend.searchFlag=false
              if(_this.recommend.chooseIndex>0){
                _this.recommend.chooseIndex--;
                _this.useMessageByContent(_this.recommend.chooseIndex,list[_this.recommend.chooseIndex].text);
              }
            }else if(keyCode == 40){//下移
              _this.recommend.searchFlag=false
              if(_this.recommend.chooseIndex<4){
                _this.recommend.chooseIndex++;
                _this.useMessageByContent(_this.recommend.chooseIndex,list[_this.recommend.chooseIndex].text);
              }
            }else if(keyCode ==13){
              _this.recommend.searchFlag=true
              if(_this.recommend.show){
                _this.sendMessage();
                _this.recommend.show=false;
                _this.recommend.chooseIndex=0;
              }

            }else{
              _this.recommend.searchFlag=true
              _this.recommend.show=false;
              _this.recommend.chooseIndex=0;
            }
          }
        }
      },

      /**
       * 按钮点击人工客服
       */
      transferStaffSession:function () {
        // chatDataCenter.isOpenFeedback = true;
        // chatDataCenter.isTransformDirectly = true;
        chatDataCenter.transferStaffSession(this,2)
      },

      /**
       * 关闭人工会话
       */
      closeSessionByCustomer:function () {
        var _this = this;
        if (chatDataCenter.chatRoom==null||chatDataCenter.chatRoom.sessionId==null){
          parent.postMessage('deleteIframe', '*');
          chatDataCenter.set.windowFlag='2'
          return false;
        }
        if(chatDataCenter.chatRoom.sessionType==1){
          //机器人会话
          _this.hideIframe();
          return false;
        }
        var sessionId=chatDataCenter.chatRoom.sessionId;
        var customerEvaluate=chatDataCenter.chatRoom.customerEvaluate;
        chatDataCenter.evaluation.customerEvaluate=customerEvaluate
        chatDataCenter.evaluation.sessionId=sessionId
        chatDataCenter.evaluation.closeType='1'//1客户主动关闭
        chatDataCenter.evaluation.show=true
      },
      useMessageByContent:function (index,content) {
        content=content.replace(new RegExp(/(<em>)/g),"").replace(new RegExp("</em>", "g"),"");
        this.recommend.chooseIndex=index
        this.editor.txt.text("")
        chatDataCenter.sendMessageByContent(content)
      },
      quickConsultSendByContent:function (index,content) {
        chatDataCenter.quickConsult.chooseIndex=index
        chatDataCenter.sendMessageByContent(content)
      },
      quickConsultPre:function () {
        if(chatDataCenter.quickConsult.chooseIndex>0){
          chatDataCenter.quickConsult.chooseIndex-=1;
        }else {
          chatDataCenter.quickConsult.chooseIndex=0
        }
      },
      quickConsultNext:function () {
        if(chatDataCenter.quickConsult.chooseIndex<(chatDataCenter.quickConsult.list.length-1)){
          chatDataCenter.quickConsult.chooseIndex+=1;
        }else {
          chatDataCenter.quickConsult.chooseIndex=chatDataCenter.quickConsult.list.length-1
        }
      },
      getText:function () {
        var text = chatDataCenter.chatRoom.inputting;
        text = text.replace(/<\/?p[^>]*>/gi,'');
        text = text.replace(new RegExp("&nbsp;", "g"), "");
        text = text.replace(/[|]*\n/, '') //去除行尾空格
        text = text.replace(/<br\s*\/?>/g,"");
        text = text.replace(/\s+/g,"");
        return text;
      },
      getEditorText:function () {
        var text = this.editor.txt.html();
        text = text.replace(/<\/?p[^>]*>/gi,'');
        text = text.replace(new RegExp("&nbsp;", "g"), "");
        text = text.replace(/[|]*\n/, '') //去除行尾空格
        text = text.replace(/<br\s*\/?>/g,"");
        text = text.replace(/\s+/g,"");
        return text;
      },
      /**
       * 发送消息
       */
      sendMessage: function () {
        var _this = this;
        var text = this.getEditorText();
        if(text == ""){
          _this.showFlag.sendShow=false
          return;
        }
        _this.showFlag.sendShow=true
        text = text.replace(/<\/?[^>]*>/g, '');
        chatDataCenter.sendMessageJudge(_this,text,function () {
          chatDataCenter.chatRoom.inputting = emoji.img_emoji(_this.editor.txt.html());
          chatDataCenter.chatRoom.sendMessage('input');
          chatDataCenter.clickEvent(text,_this);
          _this.editor.txt.text("");
          _this.showFlag.sendShow=false;
        });

      },
      fromUploadData(data) {
        var _this = this;
        if (data.flag){
          var fileObj={
            url:data.url,
          }
          if(_this.$messageType.F==data.messageType){
            fileObj.name=data.name;
            fileObj.size=data.size;
          }
          chatDataCenter.sendMessageJudge(_this,'',function () {
            chatDataCenter.chatRoom.sendMessageFile(fileObj,data.messageId);
          });
        }
      },
      detail:function () {
        let routeUrl = this.$router.resolve({
          path: "./noticeDetail",
          query:{channelId:chatDataCenter.customer.sourceChannelId}
        });
        window.open(routeUrl .href, '_blank');
      },
      getRobotToUserButton:function () {
        if(chatDataCenter.linkInfo!=null&&chatDataCenter.linkInfo.artificialFlag==1&&chatDataCenter.chatRoom!=null&&chatDataCenter.chatRoom.sessionId!=null&&chatDataCenter.chatRoom.queueFlag==0&&
          (chatDataCenter.chatRoom.sessionType==1||(chatDataCenter.chatRoom.sessionType==2&&chatDataCenter.chatRoom.userId==null))){
          return '1'
        }else if(chatDataCenter.chatRoom!=null&&chatDataCenter.chatRoom.sessionId!=null&&chatDataCenter.chatRoom.sessionType==2&&chatDataCenter.chatRoom.userId!=null){
          return '2'
        }else {
          return '3'
        }
      },
      /**
       * 长文本展开收起
       */
      foldMore(item){
        item.height = item.isOpen ? "245px" : "unset";
        item.isOpen = !item.isOpen;
        const chatId=  JSON.parse(item.messageContent).chatId;
        // setTimeout(() => {
        //   this.myScroll.refresh();
        // }, 500);
      }
    },
    mounted:function () {
      var _this=this;
      _this.initEditor(false);
      _this.initPage();
    },
    data() {
      return {
        chatDataCenter,
        editor : null,
        inputShow:true,
        showFlag:{
          sendShow:false,
        },
        robotSessionFlag:true,
        recommend:{
          chooseIndex:0,
          searchFlag:true,
          show:false,
          list:[],
        },
        image:{
          flag:false,
          type:'icon_multiple_web_pic',
          className:'picfile',
          iconName:'',
        },
        file:{
          flag:false,
          type:'icon_multiple_web_file',
          className:'wjfile',
          iconName:'',
        },
      }
    },

  }
</script>


<style scoped>
  @import "../../../static/css/main.css";
  .bottomButton{
    background: #f3f4f5;
  }
  .smartnlp-chat-msg-input-button{
    position: absolute;
    height: 132px;
    box-sizing: border-box;
    bottom: 0;
    right: 0;
    left: 0;
    background: #ffffff;
    border-top: 1px solid #e8eaed;
  }
  .smartnlp-chat-msg-show-button{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 132px;
    background: #f3f4f5;
  }
  .smartnlp-write-block-botton{
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    height: 92px;
  }
  .openMore {
    text-align: center;
    font-size: 14px;
    color: #717688;
    margin: 8px 15px;
    padding: 5px 0;
    border-top: 1px solid #ebebeb;
    cursor: pointer;
  }
  .openImg {
    width: 16px;
    height: 16px;
    margin-left: 10px;
  }
</style>
